import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { ShieldCheck, Lock } from "lucide-react";

export default function Dashboard() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <div className="max-w-3xl mx-auto px-6 py-16 md:py-20">
      <p className="label-eyebrow">Your account</p>
      <h1 className="font-serif text-5xl mt-2">Hello, {user.name || user.email.split("@")[0]}.</h1>
      <hr className="divider-rule" />

      <div className="card-journal">
        <div className="flex items-center gap-3">
          {user.is_paid || user.role === "admin" ? (
            <>
              <ShieldCheck className="w-6 h-6 text-[var(--forest)]" strokeWidth={1.5} />
              <p className="font-serif text-2xl">Library access · Active</p>
            </>
          ) : (
            <>
              <Lock className="w-6 h-6 text-[var(--terracotta)]" strokeWidth={1.5} />
              <p className="font-serif text-2xl">Library access · Locked</p>
            </>
          )}
        </div>
        <p className="text-sm text-[var(--ink-soft)] mt-2">
          {user.is_paid || user.role === "admin"
            ? "You have lifetime access to the field guide. Welcome to the wild."
            : "Unlock the full library for a one-time $4."}
        </p>
        <div className="mt-6">
          {user.is_paid || user.role === "admin" ? (
            <Link to="/library" className="btn-primary">Open the library</Link>
          ) : (
            <Link data-testid="dashboard-unlock-btn" to="/unlock" className="btn-accent">Unlock for $4</Link>
          )}
        </div>
      </div>

      <div className="mt-8 grid grid-cols-2 gap-6">
        <div>
          <p className="label-eyebrow">Email</p>
          <p className="font-mono text-sm mt-2 break-all" data-testid="dashboard-email">{user.email}</p>
        </div>
        <div>
          <p className="label-eyebrow">Role</p>
          <p className="font-mono text-sm mt-2">{user.role}</p>
        </div>
      </div>
    </div>
  );
}
